import React, { useEffect, useState } from 'react'
import adminApiService from './AdminApiService'
import CommonModal from '../../services/CommonModal';
import { toast } from 'react-toastify';

const emptyForm = {
    code: "",
    name: "",
    symbol: "",
    numeric_code: "",
    decimal_places: "",
    is_active: false,
    is_base: false,
}

const Currencies = () => {
    const [dataApi, setDataApi] = useState([]);
    const [leading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currencyModal, setCurrencyModal] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [formData, setFormData] = useState(emptyForm);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 })

    useEffect(() => {
        getCurrencies();
    }, [])

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const getCurrencies = async () => {
        setLoading(true)
        try {
            const res = await adminApiService.getCurrencies();
            setDataApi(res?.currencies ?? []);
            console.log("get countries===", res)            
            // setPagination(res?.pagination ?? { total: 0, page: 1, pages: 1 });
        } catch (error) {
            setError(error)
            console.error("[Currencies] getCurrencies failed:", error);
        } finally {
            setLoading(false)
        }
    };

    const closeModal = () => {
        setCurrencyModal(false);
        setSelectedCurrency(null);
        setFormData(emptyForm);
    }

    const openAddModal = () => {
        setSelectedCurrency(null);
        setFormData(emptyForm);
        setCurrencyModal(true);
    }

    const createCurrencies = async (e) => {
        e.preventDefault();

        if (typeof adminApiService.createCurrencies !== "function") {
            console.error("createCurrencies");
            toast.error("Create failed")
            return;
        }

        const payload = {
            code: formData.code,
            name: formData.name,
            symbol: formData.symbol,
            numeric_code: formData.numeric_code,
            decimal_places: formData.decimal_places,
            is_active: formData.is_active,
            is_base: formData.is_base,
        }
        closeModal();

        try {
            await adminApiService.createCurrencies(payload);
            toast.success("Created Currency successfuly")
            getCurrencies();
        } catch (error) {
            console.error("Create Currencies failed:", error);
            toast.error(`Create Currencies failed`)
        }
    }
  
    const updateCurrencies = async (e) => {
        e.preventDefault();

        if (!selectedCurrency?.id) {
            console.error("[Currencies] Currency ID is missing");
            return;
        }

        if (typeof adminApiService.updateCurrencies !== "function") {
            console.error(" update Currencies is not failed");
            toast.error("Update Update Currencies failed ")
            return;
        }

        const currencyId = selectedCurrency.id;
        const payload = {
            code: formData.code,
            name: formData.name,
            symbol: formData.symbol,
            numeric_code: formData.numeric_code,
            decimal_places: formData.decimal_places,
            is_active: formData.is_active,
            is_base: formData.is_base,
        }
        closeModal();
        try {
            await adminApiService.updateCurrencies(currencyId, payload)
            getCurrencies();
        } catch (error) {
            console.error("[Currencies] updateCurrencies failed:", error);
            console.error("[Currencies] server response:", error?.response?.data);
            // alert(`Update failed: ${error?.response?.data?.message || error?.message || "Unknown error"}`);
            toast.error(`Update failed: ${error?.response?.data?.message || error?.message || "Unknown error"}`)
        }
    }

    const handleEditCurrency = (item) => {
        setSelectedCurrency(item);

        setFormData({
            code: item.code || "",
            name: item.name || "",
            symbol: item.symbol || "",
            numeric_code: item.numeric_code || "",
            decimal_places: item.decimal_places ?? 2,
            is_active: item.is_active === true || item.is_active === "true",
            is_base: item.is_base === true || item.is_base === "true",
        });
        setCurrencyModal(true);
    }

    const deleteCurrency = async () => {
        // const confirmed = window.confirm(`Delete currency "${item.code} - ${item.name}"? This cannot be undone.`);
        // if (!confirmed) return;

        if (typeof adminApiService.deleteCurrency !== "function") {
            console.error("removeCurrency");
            toast.error("Delete delete Currency failed ")
            return;
        }

        try {
            await adminApiService.deleteCurrency(selectedId);
            getCurrencies();
        } catch (error) {
            console.error("[Currencies] deleteCurrency failed:", error);
            toast.error(`Delete failed: ${error?.response?.data?.message || error?.message || "Unknown error"}`)
        }
    }

    const confirmDelete = () => {
        deleteCurrency(selectedId);
        setShowDeleteModal(false);
        setSelectedId(null);
    };

    const handleDeleteClick = (id) => {
        setSelectedId(id.id);
        setShowDeleteModal(true);
    };

    return (
        <>
            <div className="admin-plans">
                <div className="page-header !border-none !pb-0">
                    <h1>Currencies</h1>
                    <div className="filter-buttons">
                        <button className="active" onClick={openAddModal}>Add Currencies</button>
                    </div>
                </div>

                <div className="table-responsive overflow-x-auto bg-white rounded-lg shadow border border-gray-200 mt-5">
                    <table className="table squad-table">
                        <thead>
                            <tr>
                                <th>Currency Code </th>
                                <th>Currency Name </th>
                                <th>Currency Symbol </th>
                                <th>Numeric code </th>
                                <th>Decimal places </th>
                                <th>Is Active </th>
                                <th>Is base </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataApi.length > 0 ? (
                                dataApi.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.code}</td>
                                        <td>{item.name}</td>
                                        <td>{item.symbol}</td>
                                        <td>{item.numeric_code}</td>
                                        <td>{item.decimal_places}</td>
                                        <td>{item.is_active ? "Yes" : "No"}</td>
                                        <td>{item.is_base ? "Yes" : "No"}</td>

                                        <td>
                                            <div className="action-buttons">
                                                <button
                                                    className="btn btn-sm btn-outline-primary custom-pbtn"
                                                    title="Edit"
                                                    onClick={() => handleEditCurrency(item)}
                                                >
                                                    <i className="fas fa-edit custom-fas-icon"></i>
                                                </button>

                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    title="Delete"
                                                    onClick={() => handleDeleteClick(item)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        No currencies found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>

            {currencyModal && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
                    onClick={closeModal}
                >
                    <div
                        className="w-[50%] overflow-hidden rounded-xl bg-white shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div
                            className="flex items-center justify-between px-6 py-4"
                            style={{ background: "#1F2937" }}
                        >
                            <h2 className="text-lg font-semibold text-white">
                                {selectedCurrency ? "Edit Currency" : "Add Currency"}
                            </h2>

                            <button
                                onClick={closeModal}
                                className="text-3xl leading-none text-white transition hover:text-gray-200"
                            >
                                &times;
                            </button>
                        </div>

                        <div className="max-h-[60vh] overflow-y-auto p-4 gap-4">
                            <form onSubmit={selectedCurrency ? updateCurrencies : createCurrencies}>
                                <div className="grid md:grid-cols-12 gap-4">
                                    <div className="md:col-span-4">
                                        <div className='form-group'>
                                            <label className="mb-2 block text-sm font-medium text-gray-700">
                                               Currency Code
                                            </label>
                                            <input type='text' className='form-control'
                                                name="code"
                                                value={formData.code}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="md:col-span-4">
                                        <div className='form-group'>
                                            <label className="mb-2 block text-sm font-medium text-gray-700">
                                               Currency Name
                                            </label>
                                            <input type='text' className='form-control'
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="md:col-span-4">
                                        <div className='form-group'>
                                            <label className="mb-2 block text-sm font-medium text-gray-700">
                                               Currency Symbol
                                            </label>
                                            <input type='text' className='form-control'
                                                name="symbol"
                                                value={formData.symbol}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="md:col-span-4">
                                        <div className='form-group'>
                                            <label className="mb-2 block text-sm font-medium text-gray-700">
                                                Numeric code
                                            </label>
                                            <input type='text' className='form-control'
                                                name="numeric_code"
                                                value={formData.numeric_code}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="md:col-span-4">
                                        <div className='form-group'>
                                            <label className="mb-2 block text-sm font-medium text-gray-700">
                                                Decimal places
                                            </label>
                                            <input type='number' className='form-control'
                                                name="decimal_places"
                                                value={formData.decimal_places}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="md:col-span-4 pt-8">
                                        <div className='mb-3'>
                                            <label className="flex items-center block text-sm font-medium text-gray-700">
                                                <input type='checkbox' className='me-3'
                                                    name="is_active"
                                                    checked={formData.is_active}
                                                    onChange={handleChange} />  Is Active
                                            </label>
                                        </div>
                                        <div className=' '>
                                            <label className="flex items-center block text-sm font-medium text-gray-700">
                                                <input type='checkbox' className='me-3'
                                                    name="is_base"
                                                    checked={formData.is_base}
                                                    onChange={handleChange} />  Is base
                                            </label>

                                        </div>
                                    </div>
                                    <div className="md:col-span-4">

                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <button type="submit" className="btn btn-sm btn-primary">
                                        {selectedCurrency ? "Update" : "Create"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            )}

            <CommonModal
                isOpen={showDeleteModal}
                title="Delete Currency"
                message="Are you sure you want to delete this Currency?"
                onClose={() => {
                    setShowDeleteModal(false);
                    setSelectedId(null);
                }}
                onConfirm={confirmDelete}
                type="error"
                confirmText="Delete"
                cancelText="Cancel"
            />
        </>
    )
}

export default Currencies